import { fetchTinybird } from "#web/services/tinybird";
import { queryOptions } from "@tanstack/react-query";
import * as v from "valibot";

export const VerifyCheckoutExtensionInstalledQuery = ({ shopId }: { shopId: string | undefined }) =>
  queryOptions({
    enabled: !!shopId,
    queryFn: async () => {
      const data = await fetchTinybird("ce_installed", { shopId: shopId! });
      const { rows } = v.parse(v.object({ rows: v.optional(v.number()) }), data);

      return { installed: (rows ?? 0) > 0 };
    },
    queryKey: ["verify-checkout-extension-installed", shopId],
  });
